import { render, staticRenderFns } from "./MultipleChoiceType.vue?vue&type=template&id=25c974e4&"
import script from "./MultipleChoiceType.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports